var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-table", {
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "header-cell-style": {
        background: "#eef1f6",
        color: "#606266"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      height: "150",
      label: "区服",
      prop: "server_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.serverList[scope.row.server_id]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "角色ID",
      prop: "role_id"
    }
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "角色名",
      prop: "role_name"
    }
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "角色等级",
      prop: "role_level"
    }
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "变更时间",
      prop: "log_time"
    }
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "变更类型",
      prop: "type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.changeTypeOption[scope.row.type]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "伙伴",
      prop: "partner_config_id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.partnerList[scope.row.partner_config_id]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "伙伴品质",
      prop: "partner_quality"
    }
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "伙伴等级",
      prop: "partner_level"
    }
  }), _c("el-table-column", {
    attrs: {
      height: "150",
      label: "变更原因",
      prop: "change_reason"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.reasonList[scope.row.change_reason]) + " ")];
      }
    }])
  })], 1)], _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 30, 50, 100, 500],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };